module.exports = {"productFilters":[{"type":"text","name":"Product Name","placeholder":"Wifi Product Name","field":"q"},{"type":"selector","name":"Source","field":"iso_code","selectors":[{"label":"Passpod","value":"ID","restriction":"PH"},{"label":"Passpod PH","value":"PH"}]},{"type":"selector","name":"Status","field":"status","selectors":[{"label":"All","value":""},{"label":"Active","value":"active"},{"label":"Inactive","value":"inactive"}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/Pages/filterData.json
// module id = 920
// module chunks = 0